import axios from 'axios';

// API 에러 처리를 위한 유틸리티 함수
// error: 처리할 에러 객체
// defaultMessage: 기본 에러 메시지 (기본값: '요청 처리 중 오류가 발생했습니다.')
export const handleApiError = (error: unknown, defaultMessage = '요청 처리 중 오류가 발생했습니다.') => {
    // axios 에러인지 확인
    if (axios.isAxiosError(error)) {
        // 네트워크 연결 실패 에러 처리 (서버 연결 불가)
        if (error.code === 'ERR_NETWORK') {
            throw new Error('네트워크 오류가 발생했습니다. 서버가 실행 중인지 확인해주세요.');
        }

        // 서버 응답이 없는 경우 처리
        if (!error.response) {
            throw new Error('서버에 연결할 수 없습니다. 연결 상태와 서버 상태를 확인해주세요.');
        }

        // API 응답에 success가 false인 경우 처리
        // 서버에서 전달한 에러 메시지를 사용
        if (error.response.data && !error.response.data.success) {
            throw new Error(error.response.data.data.message);
        }

        // 그 외 axios 에러는 기본 메시지로 처리
        throw new Error(defaultMessage);
    }

    // axios 에러가 아닌 경우 원본 에러를 그대로 throw
    throw error;
};